module.exports = __webpack_public_path__ + "img/symbol_11.801ff2ac.png";